import { ReactNode, useId } from 'react';
import { Element, Icon } from 'react-bulma-components';
import { onEnterOrSpaceKey } from '../../shared/utils';
import styles from './admin-user-access-action-card.module.scss';

export type AdminUserAccessActionCardProps = {
  title: string;
  subtitle: string;
  icon: ReactNode;
  onClick: () => void;
};

export function AdminUserAccessActionCard({
  title,
  subtitle,
  icon,
  onClick,
}: AdminUserAccessActionCardProps) {
  const titleId = useId();
  const subtitleId = useId();

  return (
    <Element
      display="flex"
      flexDirection="column"
      className={`is-clickable ${styles.container}`}
      onClick={onClick}
      onKeyDown={onEnterOrSpaceKey(onClick)}
      alignItems="center"
      role="button"
      tabIndex={0}
      aria-labelledby={titleId}
      aria-describedby={subtitleId}
    >
      <span id={titleId} className="is-size-5 p-3">
        {title}
      </span>
      <Icon color="primary-dark" className={styles.iconContainer}>
        {icon}
      </Icon>
      <span id={subtitleId} className="is-size-7 p-4">
        {subtitle}
      </span>
    </Element>
  );
}

export default AdminUserAccessActionCard;
